import { defineMessage } from 'services/localization';

export const messages = {
    connectButtonText: defineMessage('connect'),
    xeroTitle: defineMessage('xero'),
    xeroDescription: defineMessage('connect_to_your_xero_ac_nvoices_ar_credit_notes'),
    qbTitle: defineMessage('quickbooks_online'),
    qbDescription: defineMessage('connect_to_your_quickbo_ase_orders_and_expenses'),
    learnMoreText: defineMessage('learn_more'),
    sectionHeader: defineMessage('connect_your_accounting_software_1'),
    xeroConnectButtonTitle: defineMessage('connect_to_your_xero_account'),
    qbConnectButtonTitle: defineMessage('connect_to_your_quickbooks_online_account'),
};
